import { FC, useEffect, useState } from 'react';
import { toast } from "@/components/ui/use-toast";

const LOGO_URL = "https://media.financieramente.kids/logo-financieramente.png";
const FALLBACK_LOGO = "/placeholder.svg";

interface LogoProps {
  className?: string;
}

export const Logo: FC<LogoProps> = ({ className = "h-16 w-auto" }) => {
  const [imgSrc, setImgSrc] = useState(LOGO_URL);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.src = LOGO_URL;

    img.onload = () => {
      setImgSrc(LOGO_URL);
      setIsLoading(false);
    };

    img.onerror = () => {
      console.error('Error loading logo');
      setImgSrc(FALLBACK_LOGO);
      setIsLoading(false);
      toast({
        title: "Error al cargar el logo",
        description: "Se está usando una imagen de respaldo",
        variant: "destructive",
      });
    };
  }, []);

  return (
    <img
      src={imgSrc}
      alt="Financieramente Logo"
      className={`${className} ${isLoading ? 'animate-pulse' : ''}`}
      style={{ 
        objectFit: 'contain',
        imageRendering: 'auto',
        maxWidth: 'none'
      }}
      loading="eager"
      decoding="async"
    />
  );
};